import axios, { AxiosRequestConfig } from 'axios'
import {
  GetGeneralSettingsResponseDto,
  UpdateGeneralCommissionSettingsRequestDto,
  UpdateGeneralCommissionSettingsResponseDto,
} from '@sparling/financial-common'

export const fetchGeneralSettings = async (
  { token }: { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetGeneralSettingsResponseDto> => {
  const response = await axios.get<GetGeneralSettingsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/general-settings`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateGeneralCommissionSettings = async (
  { token, ...data }: UpdateGeneralCommissionSettingsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateGeneralCommissionSettingsResponseDto> => {
  const response = await axios.post<UpdateGeneralCommissionSettingsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/general-settings/commission/update`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
